module.exports = __webpack_public_path__ + "static/media/user-tamara-idencras.298006b0.png";